import React, { useState } from "react";
import { Button, Card, Badge } from "react-bootstrap";
import { useAPI, useAPIPost } from "./API";
import { useLocalizedStrings } from "./Localization";


type ExceptionContentProps = {
    kind: string
}

function ExceptionContent(props: ExceptionContentProps) {
    const L = useLocalizedStrings();
    const [exceptions, refresh] = useAPI("/exceptions/" + props.kind, true);
    const resolved = useAPIPost("/exceptions/{fingerprint}/mark_resolved/{resolved}")

    return (<ul>
        {exceptions.exceptions && exceptions.exceptions.map((exc: any) => {
            async function markResolved(r: boolean) {
                await resolved({resolved: r}, "/exception/" + exc.fingerprint + "/mark_resolved");
                refresh();
            }
            async function mute(m: boolean) {
                await resolved({muted: m}, "/exception/" + exc.fingerprint + "/mark_muted");
                refresh();
            }

            return (
                <Card key={exc.fingerprint} style={{'marginBottom': '20px'}}>
                    <Card.Header> 
                        <b>{exc.count} {L.exceptions.times}</b>&nbsp;
                        {exc.resolved && <Badge variant="success">{L.exceptions.resolved}</Badge>}
                        {exc.muted && <Badge variant="warning">{L.exceptions.muted}</Badge>} &nbsp;
                        <b>{L.exceptions.last_seen}:</b> {exc.last_seen} &nbsp;
                        <b>{L.exceptions.first_seen}:</b> {exc.first_seen} &nbsp;
                        {exc.fingerprint} &nbsp;
                        <Button onClick={() => markResolved(!exc.resolved)} variant="success">{exc.resolved ? L.exceptions.unresolve : L.exceptions.resolve}</Button> &nbsp;
                        <Button onClick={() => mute(!exc.muted)} variant="warning">{exc.muted ? L.exceptions.unmute : L.exceptions.mute}</Button>
                        </Card.Header>
                    <Card.Body> <pre>{exc.trace}</pre> </Card.Body>
                </Card>
            );
        })}
    </ul>);
}

function ExceptionsPage() {
    const L = useLocalizedStrings();
    const [kind, setKind] = useState("latest");
    function toggleView() {
        if (kind === 'latest') {
            setKind('all');
        } else {
            setKind('latest');
        }
    }
    return <div className="p-5">
        <h1>{kind === 'latest' ? L.exceptions.latest_exceptions : L.exceptions.all_exceptions}</h1>
        <Button onClick={toggleView}>{L.exceptions.show} {kind === 'latest' ? L.exceptions.all_exceptions : L.exceptions.latest_exceptions}</Button><br /><br />
        <ExceptionContent kind={kind} />
    </div>;
}

export default ExceptionsPage; 